import { createSlice } from '@reduxjs/toolkit'

export const localeSlice = createSlice({
  name: 'questionnaireMetadata',
  initialState: 'nl',
  reducers: {
    SET_LOCALE: (state, action) => {
      return action.payload.locale
    },
  },
})

export const { SET_LOCALE } = localeSlice.actions

export default localeSlice.reducer
